import {
  EDITION_ID_EN_AU,
  EDITION_ID_EN_GB,
  EDITION_ID_DE_DE,
  EDITION_ID_EN_CA,
  EDITION_ID_FR_FR
} from '../constants';
/*
 * Implicitly tested in actions/i18n
 */
export default edition_id => {
  let loadLocale;
  switch (edition_id) {
    case EDITION_ID_EN_CA:
      loadLocale = import(/* webpackChunkName: "locale_en_ca" */ '../locales/en-ca');
      break;
    case EDITION_ID_EN_AU:
      loadLocale = import(/* webpackChunkName: "locale_en_au" */ '../locales/en-au');
      break;
    case EDITION_ID_EN_GB:
      loadLocale = import(/* webpackChunkName: "locale_en_gb" */ '../locales/en-gb');
      break;
    case EDITION_ID_DE_DE:
      loadLocale = import(/* webpackChunkName: "locale_de_de" */ '../locales/de-de');
      break;
    case EDITION_ID_FR_FR:
      loadLocale = import(/* webpackChunkName: "locale_fr_FR" */ '../locales/fr-fr');
      break;
    default:
      loadLocale = import(/* webpackChunkName: "locale_en_us" */ '../locales/en-us');
  }
  return loadLocale.then(localeExports => localeExports.default);
};
